import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Box } from "@material-ui/core";

import { FieldBuilder } from "../FieldBuilder";
import { ImageBlock } from "../ImageBlock";

const ManualCommercialTable = ({
  classes,
  property,
  setProperty,
  isAddressEmpty,
  isEditMode,
  type,
}) => {
  const category = useSelector(
    ({ appraisal }) => appraisal.meta.category,
    shallowEqual,
  );

  const onSetProperty = (name, value) =>
    setProperty({ ...property, [name]: value });
  return (
    <React.Fragment>
      <div className="d-flex">
        <div className={classes.imageBlock}>
          <Box width="100%">
            <ImageBlock
              classes={classes}
              image={property.image}
              setImage={value => onSetProperty("image", value)}
              id={property?.id}
              isEditMode={isEditMode}
            />
          </Box>
        </div>
        <div className={classes.addressBlockInWithImageBlock}>
          <div className={classes.addressBlock}>
            <FieldBuilder
              className={classes.inputContainer}
              label={"Address"}
              value={property.address}
              onChange={value => onSetProperty("address", value)}
              placeholder={"eg. 10 Street Name, Suburb State Postcode"}
              isRequired={isAddressEmpty && !property.address}
            />
          </div>
          <div className={classes.infoBlockInWithImageBlock}>
            <FieldBuilder
              className={classes.inputContainer}
              label={"Land Area"}
              value={property.landArea}
              onChange={value => onSetProperty("landArea", value)}
              placeholder={"eg. 100 sqm"}
            />
            <FieldBuilder
              className={classes.inputContainer}
              label={"Building Area"}
              value={property.buildingArea}
              onChange={value => onSetProperty("buildingArea", value)}
              placeholder={"eg. 100 sqm"}
            />
            {["On the Market", "Market Sales"].includes(type) && (
              <FieldBuilder
                className={classes.inputContainer}
                label={"Floor Area"}
                value={property.floorArea}
                onChange={value => onSetProperty("floorArea", value)}
                placeholder={"eg. 100 sqm"}
              />
            )}
          </div>
        </div>
      </div>
      <div style={{ display: "flex", width: "100%" }}>
        <div style={{ width: "50%" }}>
          <FieldBuilder
            className={classes.inputContainer}
            label={`${category === "lease" ? "" : "Sale "}Price`}
            value={property.price}
            onChange={value => onSetProperty("price", value)}
            placeholder={"eg. $300,000"}
            isPreClick
          />
        </div>
        <div style={{ width: "50%" }}>
          <FieldBuilder
            className={classes.inputContainer}
            label={"Rate per sqm"}
            value={property.ratePerSqm}
            onChange={value => onSetProperty("ratePerSqm", value)}
            placeholder={"eg. $300,000"}
            isPreClick
          />
        </div>
      </div>
      <div style={{ display: "flex", width: "100%" }}>
        <div style={{ width: "100%" }}>
          <FieldBuilder
            className={classes.inputContainer}
            label={`${category === "lease" ? "Lease" : "Sale"} Date`}
            value={property.saleDate}
            onChange={value => onSetProperty("saleDate", value)}
            placeholder={"eg. 31/01/2022"}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default ManualCommercialTable;
